import { Box } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';

const OCR_SCAN_ANIMATION_SRC = '/animations/scan-document.lottie';

export const OCR_SCAN_ANIMATION_TEST_ID = 'ocr-scan-animation';

export const OcrScanAnimation = () => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;

    let isDisposed = false;
    let dotLottie: { destroy: () => void } | null = null;

    const loadAnimation = async () => {
      const { DotLottie } = await import('@lottiefiles/dotlottie-web');
      if (isDisposed) return;

      dotLottie = new DotLottie({
        autoplay: true,
        canvas,
        layout: {
          align: [0.5, 0.5],
          fit: 'contain',
        },
        loop: true,
        renderConfig: {
          autoResize: true,
        },
        src: OCR_SCAN_ANIMATION_SRC,
      });
    };

    void loadAnimation();

    return () => {
      isDisposed = true;
      dotLottie?.destroy();
    };
  }, []);

  return (
    <Box aria-hidden="true" h="88px" w="88px">
      <canvas
        data-testid={OCR_SCAN_ANIMATION_TEST_ID}
        ref={canvasRef}
        style={{
          display: 'block',
          height: '88px',
          width: '88px',
        }}
      />
    </Box>
  );
};
